const AppleLogo = () => {
  return (
    <svg width='18.75' height='22' viewBox='0 0 37 47' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.0492 10.8462C21.1016 10.8462 23.6742 9.41195 25.2063 7.49968C26.5938 5.76669 27.6055 3.34647 27.6055 0.926254C27.6055 0.597583 27.5766 0.268913 27.5188 0C25.2352 0.0896377 22.4891 1.5836 20.8414 3.5855C19.5406 5.10934 18.3555 7.49968 18.3555 9.94978C18.3555 10.3083 18.4133 10.6669 18.4422 10.7864C18.5867 10.8163 18.818 10.8462 19.0492 10.8462ZM11.8227 47C14.6266 47 15.8695 45.0578 19.3672 45.0578C22.9227 45.0578 23.7031 46.9402 26.825 46.9402C29.8891 46.9402 31.9414 44.0121 33.8781 41.1437C36.0461 37.857 36.9422 34.63 37 34.4806C36.7977 34.4209 30.9297 31.9409 30.9297 24.979C30.9297 18.9434 35.5547 16.2244 35.8148 16.0153C32.7508 11.4736 28.0969 11.3541 26.825 11.3541C23.3852 11.3541 20.5813 13.5054 18.818 13.5054C16.9102 13.5054 14.3953 11.4736 11.418 11.4736C5.75234 11.4736 0 16.314 0 25.4571C0 31.1341 2.13906 37.1399 4.76953 41.0242C7.02422 44.3109 8.98984 47 11.8227 47Z'
        shapeRendering='geometricPrecision'
        fill='black'
      ></path>
    </svg>
  );
};

export default AppleLogo;
